import { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { rememberReturnTarget, takeReturnTarget } from "../lib/loginReturn";

/**
 * Sends a signed-out visitor to /login and remembers the full page they
 * asked for (path, query and hash) so sign-in can bring them back.
 */
export function LoginRedirect() {
  const location = useLocation();
  useEffect(() => {
    rememberReturnTarget(`${location.pathname}${location.search}${location.hash}`);
  }, [location.pathname, location.search, location.hash]);
  return <Navigate to="/login" replace />;
}

/**
 * Renders nothing. Mount it only after auth and the setup check have passed.
 * Moves the person to the page they originally opened, once per mount, then
 * forgets it. A page their role cannot open still shows the normal denial
 * (no loop: the target is deleted before navigating).
 */
export function ReturnTargetConsumer() {
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const target = takeReturnTarget();
    if (target) navigate(target, { replace: true });
  }, [navigate]);
  return null;
}
